import React, { useState } from "react";
import { Table } from "../../../components/CustomPaginations";
import { Container, Row } from "react-bootstrap";
import { Button } from "reactstrap";
import axios from "axios";
import moment from "moment";
import { UserConsumer } from "../../../UserContext";
import { myOfficeHoursAPIs } from "./myOfficeHoursAPIs";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { officeHoursTableStyle } from "../../ticketModule/variables/ListingVariables";
import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";
import { GlobalPaginationSize } from "../../../components/GlobalPaginationSize";

const HoursTable = (props) => {
	let token = null;
	const { tableData, setTableData, workStatus, isLoading, setIsLoading } =
		props;
	const { checkedOutAt } = tableData;
	const defaultSorted = [
		{
			dataField: "recordId",
			order: "desc",
		},
	];
	const [pageNum, setPageNum] = useState(1);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.AdminPaginationSize
	);
	const [exportExcelDownloading, setExportExcelDownloading] = useState(false);
	const [sortBy, setSortBy] = useState([defaultSorted[0]]);
	const columns = [
		{
			dataField: "employeeID",
			text: "Emp Code",
			sort: false,
		},
		{
			dataField: "recordId",
			text: "Record Id",
			sort: true,
		},
		{
			dataField: "employeeName",
			text: "Emp Name",
			sort: true,
		},
		{
			dataField: "recordDate",
			text: "Date",
			sort: true,
			formatter: (recordData) => {
				return moment(recordData).format("DD/MM/YYYY");
			},
		},
		{
			dataField: "recordDay",
			text: "Record Day",
			sort: false,
		},
		{
			dataField: "checkedInAt",
			text: "Checkin Time",
			sort: false,
			formatter: (checkedInAt) => {
				return checkedInAt ? moment(checkedInAt).format("HH:mm") : null;
			},
		},
		{
			dataField: "checkedOutAt",
			text: "Checkout Time",
			sort: false,
			formatter: (cell, data) => {
				const { checkedInAt, checkedOutAt } = data;
				return checkedOutAt === null && checkedInAt ? (
					<span style={{ color: "red" }}>CheckOut Missing</span>
				) : checkedInAt ? (
					moment(checkedOutAt).format("HH:mm")
				) : null;
			},
			style: (checkedOutAt) => {
				return checkedOutAt === "CheckOut Missing"
					? { color: "red" }
					: checkedOutAt === "Present"
					? { color: "rgb(67, 163, 165)" }
					: checkedOutAt === "Late"
					? { color: "red" }
					: { color: "rgb(67, 163, 165)" };
			},
		},
		{
			dataField: "hoursWorked",
			text: "Hours Worked",
			sort: false,
		},
	];

	const exportToExcel = () => {
		setExportExcelDownloading(true);
		axios({
			url: `${myOfficeHoursAPIs.GetExportToExcelAPI}?FromDate=${moment(
				props.startDate
			).format(APIDateFormat)}&ToDate=${moment(props.endDate).format(
				APIDateFormat
			)}&EmployeeId=${props.workStatus}`,
			method: "GET",
			responseType: "blob",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "ExportAttendance.xlsx");
				document.body.appendChild(link);
				link.click();
				setExportExcelDownloading(false);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Select Date",
					});
				}
				setExportExcelDownloading(false);
			});
	};

	const receiveData = (PageSize) => {
		//call api on table page size changed
		setIsLoading(true);
		axios
			.get(
				`${
					myOfficeHoursAPIs.GetEmployeesAttendance_API
				}?FromDate=${moment(props.startDate).format(
					APIDateFormat
				)}&ToDate=${moment(props.endDate).format(
					APIDateFormat
				)}&EmployeeId=${workStatus}&PageSize=${PageSize}&PageNumber=${1}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				setIsLoading(false);
				setNumberOfItemsPerPage(PageSize);
				props.setNumberOfItemsPerPage(PageSize);
				setTableData(res.data.employeeAttendanceListing);
				props.setPagerData(JSON.parse(res.headers["x-pagination"]));
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: "Please Enter Start Date",
					});
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		//call api on table sorting and pagination
		setIsLoading(true);

		let getData = false;
		let apiURL = "";
		setSortBy({ dataField: sortField, order: sortOrder });
		if (type === "sort") {
			apiURL = `${
				myOfficeHoursAPIs.GetEmployeesAttendance_API
			}?FromDate=${moment(props.startDate).format(
				APIDateFormat
			)}&ToDate=${moment(props.endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&EmployeeId=${
				props.workStatus
			}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${
				myOfficeHoursAPIs.GetEmployeesAttendance_API
			}?FromDate=${moment(props.startDate).format(
				APIDateFormat
			)}&ToDate=${moment(props.endDate).format(
				APIDateFormat
			)}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&EmployeeId=${
				props.workStatus
			}&SortBy=${sortField}_${sortOrder}`;
			getData = true;
		}

		//call api
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setTableData(res.data.employeeAttendanceListing);
						props.setPagerData(
							JSON.parse(res.headers["x-pagination"])
						);
					}
				});
		}
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ||
					userDetails.empRole.includes("5") ? ( //authorization
					<Container fluid className="p-0">
						<Row className="d-flex justify-content-end pr-4 pt-3">
							{/*Button Container*/}
							<Button
								onClick={exportToExcel}
								className="d-flex exportExcel-btn"
								disabled={
									!tableData.length || exportExcelDownloading
								}
							>
								{exportExcelDownloading ? (
									<>
										<span
											class="spinner-border spinner-border-sm"
											role="status"
											aria-hidden="true"
										></span>
										<span className="pl-2">
											Export to Excel
										</span>
									</>
								) : (
									<span>Export to Excel</span>
								)}
							</Button>
						</Row>

						{/* Table with Pagonation*/}
						<PaginationProvider
							pagination={paginationFactory({
								custom: true,
								totalSize: props.pagerData
									? props.pagerData.TotalCount
									: 0,
								page: pageNum,
								sizePerPage: numberOfItemsPerPage,
								paginationSize: numberOfItemsPerPage,
							})}
						>
							{({ paginationProps, paginationTableProps }) => {
								return (
									<Table
										keyField="id"
										columns={columns}
										items={tableData}
										tableStyle={officeHoursTableStyle}
										paginationProps={paginationProps}
										paginationTableProps={
											paginationTableProps
										}
										defaultSorted={defaultSorted}
										bodyClasses={
											checkedOutAt ? "hours-trow" : null
										}
										pagerData={props.pagerData}
										onTablePageChange={handleTableChange}
										SearchBar={() => {
											return null;
										}}
										receiveData={(PageSize) => {
											receiveData(PageSize);
										}}
										loading={isLoading}
										tableLoader={isLoading}
										adminPagination={userDetails.empRole.includes(
											"3"
										)}
									/>
								);
							}}
						</PaginationProvider>
					</Container>
				) : (
					<Redirect to="/MyDashboard" /> //redirection for unauthorized users
				);
			}}
		</UserConsumer>
	);
};

export default HoursTable;
